var chunkToChildrenMap = {
	"extensions_cornerstone_src_index_tsx": [
		"vendors-node_modules_react-resize-detector_build_index_esm_js",
		"extensions_cornerstone_src_Viewport_OHIFCornerstoneViewport_tsx"
	],
	"extensions_cornerstone-dicom-sr_src_index_tsx": [
		"extensions_cornerstone-dicom-sr_src_viewports_OHIFCornerstoneSRViewport_tsx"
	],
	"extensions_measurement-tracking_src_index_tsx": [
		"extensions_cornerstone-dicom-sr_src_viewports_OHIFCornerstoneSRViewport_tsx",
		"extensions_measurement-tracking_src_viewports_TrackedCornerstoneViewport_tsx"
	],
	"extensions_cornerstone-dicom-seg_src_index_tsx": [
		"extensions_cornerstone-dicom-seg_src_viewports_OHIFCornerstoneSEGViewport_tsx"
	],
	"extensions_dicom-pdf_src_index_tsx": [
		"extensions_dicom-pdf_src_viewports_OHIFCornerstonePdfViewport_tsx"
	],
	"extensions_dicom-video_src_index_tsx": [
		"extensions_dicom-video_src_viewports_OHIFCornerstoneVideoViewport_tsx"
	],
	"extensions_cornerstone-dicom-rt_src_index_tsx": [
		"extensions_cornerstone-dicom-rt_src_viewports_OHIFCornerstoneRTViewport_tsx"
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));